import React , {
    useState,
    useContext,
    useEffect
} from "react";
import Layout from "../components/layout";
// import { ProductsContext } from "../context/products-context";
import { 
    Typography, 
    Box, 
    Container, 
    Grid2,
    FormControl,
    MenuItem,
    InputLabel,
    Select,
    Paper
} from "@mui/material";
// import { grey } from "@mui/material/colors";
// import ProductGallery from "../components/productGallery";
// import { useNavigate} from "react-router-dom";
// import Fake from "../components/fake";
import { styled, useTheme } from '@mui/material/styles';
// import CircularProgress from '@mui/material/CircularProgress';
import { Helmet } from "react-helmet";
import { grey } from "@mui/material/colors";
// import { Container } from "@mui/material";
// import IconBreadcrumbs from "../components/iconBreadCrumbs";
import PantryProgress from "../components/pantryCircularProgress";

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from "dayjs";
// import img1 from '../assets/image6.jpg';
import img3 from '../assets/uni-Edit.jpeg';
// import img2 from '../assets/image22.jpg';
import img4 from '../assets/apple-tartlet.jpg';
import Emailform2 from "../components/emailForm2";
// import menu from '../assets/Spring & summer menu.png';
import EchoOfSpring from "../assets/AC5A5531-Edit.jpeg";
import colorOfDeep from "../assets/AC5A5592-Edit.jpeg";

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
      backgroundColor: '#1A2027',
    }),
  }));

const StyledSelect = styled(InputLabel)(({theme}) => ({
    color: theme.palette.text.secondary,
})) 


export default function PrivateDining() {

    const [loading, setLoading] = useState(true)
    const [value, setValue] = useState(null);
    const [guests, setGuests] = useState('');
    const [cutoff, setCutoff] = useState(2);
    const theme = useTheme();

    const handleChangeGuests = (e) => {
        setGuests(e.target.value)
        }

    var tot = dayjs()

    useEffect( () => {

        setLoading(false)

        var tot = dayjs()
        setCutoff(tot.$H > 11 ? 3 : 2)

        return( () => {})

    }, [])


    return(
        <div>
            <Helmet>
                <title>Private Dining</title>
                {/* <meta name="description" content={'The pantry bakery and catering provides unique culinary experience centered around locally sourced, fresh, and mostly organic ingredients'} /> */}
                <meta name="keywords" content="private dining Los Angeles, private dining orange county, fine dining, private fine dining, romantic experience" />

                <meta property="og:title" content={'Private Dining'} />
                {/* <meta property="og:description" content={'The pantry bakery and catering provides unique culinary experience centered around locally sourced, fresh, and mostly organic ingredients'} /> */}
                {/* <meta property="og:image" content={URL of the image you want to use} /> */}
                <meta property="og:url" content={'https://thepantry.catering/private_dining'} />
                <meta property="og:type" content="website" />

                <meta name="twitter:title" content={'Private Dining'}  />
                {/* <meta name="twitter:description" content={'The pantry bakery and catering provides unique culinary experience centered around locally sourced, fresh, and mostly organic ingredients'} /> */}
            </Helmet>
            <Layout>
                <Container  maxWidth='md'>

                    {
                        loading ? 

                        <PantryProgress />

                        :

                        <Box sx={{
                            display: 'flex', 
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                            minHeight: '55vh',
                            pt: '8rem',
                            pb: '3rem',
                            }}>

                            {/* Header */}
                            <Box sx={{
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'center',
                                // background: 'red'
                                }}>
                                <Typography 
                                    textAlign={'center'} 
                                    sx={{
                                        fontFamily: 'Neuton',
                                        fontSize: {xs: 36, md: 48},
                                        lineHeight: 2,  
                                        fontWeight: 400,
                                        color: grey[800], 
                                        // pt: '4%',
                                        pb: {md: '1rem'},
                                        width: '100%', 
                                        height: '100%'}}>
                                    Private Dining
                                    {/* Welcome to The Pantry private dining, Where Every Meal is an Experience */}

                                </Typography>
                            </Box>

                            {/* Sub Header - MD +*/}
                            <Box sx={{
                                display: {xs: 'none', md: 'flex'}, 
                                alignItems: 'center', 
                                justifyContent: 'center',
                                pb: '1rem',
                                }}>

                                <Typography 
                                    textAlign={'center'} 
                                    sx={{
                                        fontFamily: 'Neuton',
                                        fontSize: {xs: 20, md: 24},
                                        // mb: '2rem',
                                        fontWeight: 300,
                                        width: '100%', 
                                        height: '100%'}}>

                                        Welcome to The Pantry private dining, where every meal is an experience

                                </Typography>
                            </Box>

                            {/* Sub Header - XS - MD*/}
                            <Box sx={{
                                display: {xs: 'flex', md: 'none'}, 
                                alignItems: 'center', 
                                justifyContent: 'center',
                                pb: '1rem',
                                }}>

                                <Typography 
                                    textAlign={'center'} 
                                    sx={{
                                        fontFamily: 'Neuton',
                                        fontSize: {xs: 20, md: 24},
                                        // mb: '2rem',
                                        fontWeight: 300,
                                        width: '100%', 
                                        height: '100%'}}>

                                        Welcome to The Pantry private dining, <br/>
                                        where every meal is an experience

                                </Typography>
                            </Box>

                            {/* Description */}
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center', 
                                justifyContent: 'center',
                                width: '95%',
                                pt: '1rem',
                                }}>

                                <Typography
                                    textAlign={'justify'} 
                                    sx={{
                                        marginBottom: '14px',
                                        fontFamily: 'Neuton',
                                        fontWeight: 300,
                                        fontSize: {xs: 16, md: 20}
                                        }}>
                                        Private dining isn’t just for special occasions—it’s for anyone who loves great food, 
                                        personalized service, and a unique culinary experience. Whether you’re gathering with 
                                        friends, celebrating a milestone, or simply indulging in an elevated meal, our thoughtfully 
                                        curated menus bring restaurant-quality dining to an intimate setting.
                                </Typography>

                            </Box>

                            {/* Menu image */}
                            {/* <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center', 
                                justifyContent: 'center',
                                width: '95%',
                                // background: 'red'
                                }}>
                                <img 
                                    src={menu} 
                                    width={'100%'} 
                                    style={{borderRadius: '0.5rem'}}
                                    alt="View from top"/>
                            </Box> */}

                            {/* Seasonal Context */}
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center', 
                                justifyContent: 'center',
                                width: '95%',
                                pt: '1rem',
                                }}>

                                <Typography
                                    textAlign={'justify'} 
                                    sx={{
                                        marginBottom: '14px',
                                        fontFamily: 'Neuton',
                                        fontWeight: 300,
                                        fontSize: {xs: 16, md: 20}
                                        }}>
                                        Spring/Summer 2025 private dining menu is a six-course ($125 per person) tasting experience, 
                                        inspired by nature - From the first green sprout of spring to the deep stillness of the ocean, 
                                        and the warmth of sunlit soil.
                                </Typography>

                            </Box>

                            {/* Image list */}
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center', 
                                justifyContent: 'center',
                                width: '100%',
                                // background: 'red'
                                }}>

                                <Grid2 container rowSpacing={{xs: 2, md: 1}} columnSpacing={{xs: 1, lg: 2}} 
                                    sx={{ alignItems: 'center', 
                                    justifyContent: 'center',
                                    width: '95%'}}>

                                    <Grid2 size={{xs: 12, sm: 6}}>
                                        <img 
                                            src={EchoOfSpring} 
                                            width={'100%'} 
                                            style={{borderRadius: '0.5rem'}}
                                            alt="View from top"/>
                                    </Grid2>

                                    <Grid2 size={{xs: 12, sm: 6}}>
                                        <img 
                                            src={colorOfDeep} 
                                            width={'100%'} 
                                            style={{borderRadius: '0.5rem'}}
                                            alt="View from top"/>
                                    {/* <Item>2</Item> */}
                                    </Grid2>

                                    <Grid2 size={{xs: 12, sm: 6}}>
                                        <img 
                                            src={img3} 
                                            width={'100%'} 
                                            style={{borderRadius: '0.5rem'}}
                                            alt="View from top"/>
                                    </Grid2>

                                    <Grid2 size={{xs: 12, sm: 6}}>
                                        <img 
                                            src={img4} 
                                            width={'100%'} 
                                            style={{borderRadius: '0.5rem'}}
                                            alt="View from top"/>
                                    </Grid2>

                                </Grid2>

                            </Box>


                            {/* Menu's Story */}
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center', 
                                justifyContent: 'center',
                                width: '95%',
                                pt: '1rem',
                                pb: '1rem',
                                // background: 'red'
                                }}>

                                <Typography
                                    textAlign={'justify'} 
                                    sx={{
                                        marginBottom: '14px',
                                        fontFamily: 'Neuton',
                                        fontWeight: 300,
                                        fontSize: {xs: 16, md: 20}
                                        }}>
                                        Each dish is built on memory, technique, and the rhythm of the natural world—not just 
                                        any cooked meal, but a sensory journey shaped by the seasons. No crowds, no rush—just 
                                        exceptional food, great company, and an experience tailored just for you. <br /> <br />

                                        Let’s make your next meal unforgettable. Book your private dining experience 
                                        today!
                                </Typography>

                            </Box>

                            {/* Reservation */}
                            <Box sx={{
                                display: 'flex', 
                                // flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center', 
                                width: '95%', 
                                // mt: '1rem',
                                mb: '2rem',
                                background: '#F8F6F1',
                                }}>

                                <Box sx={{
                                    display: 'flex', 
                                    flexDirection: {xs: 'column', md: 'row'},
                                    alignItems: 'center',
                                    justifyContent: 'center', 
                                    width: '95%',
                                    m: '1rem',
                                    }}>

                                    {/* Title */}
                                    <Box sx={{
                                        display: 'flex', 
                                        width: {xs: '100%', md: '120%'}, 
                                        alignItems: 'center', 
                                        // background: 'orange',
                                        justifyContent: 'center',}}>
                                        {value === null ? 
                                            <Typography sx={{
                                                fontFamily: 'Neuton',
                                                fontWeight: 500,
                                                fontSize: {xs: 18, md: 20},
                                                mt: {xs: '1rem', md: 0},
                                                mb: {xs: '1rem', md: 0},
                                                }}>
                                                Choose a date for your private dining event
                                            </Typography> 
                                            : 
                                            <Typography sx={{
                                                // marginBottom: '14px',
                                                fontFamily: 'Neuton',
                                                fontWeight: 500,
                                                fontSize: {xs: 16, md: 20}
                                                }}>
                                                {value.format('dddd DD/MM/YYYY')}
                                            </Typography>
                                            }
                                    </Box>

                                    {/* Date Picker */}
                                    <Box sx={{
                                        display: 'flex',
                                        width: {xs: '100%', md: '40%'},  
                                        alignItems: 'center',
                                        justifyContent: {xs: 'center', md: 'center'}, 
                                        mb: {xs: '1rem', md: 0},
                                        mt: {xs: '1rem', md: 0},
                                        // background: 'green'
                                        }}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker 
                                                label="Pickup Date" 
                                                value={value} 
                                                minDate={tot.add(cutoff, 'day')}
                                                maxDate={tot.add(3, 'month')}
                                                slotProps={{
                                                    field: {
                                                        color: theme.palette.primary.dark
                                                    }
                                                }}
                                                onChange={(newValue) => {
                                                    setValue(newValue)
                                                    }} />
                                        </LocalizationProvider>
                                    </Box>

                                    {/* Guests */}
                                    <Box sx={{
                                        display: 'flex',
                                        width: {xs: '100%', md: '35%'},  
                                        alignItems: 'center',
                                        justifyContent: {xs: 'center', md: 'center'}, 
                                        mt: {xs: '1rem', md: 0},
                                        mb: {xs: '1rem', md: 0},
                                        // background: 'green'
                                        }}>
                                        <FormControl sx={{ width: {xs: '85%'}, maxWidth: 245}}>
                                            <InputLabel id="demo-simple-select-label">
                                                Guests
                                            </InputLabel >
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={guests}
                                                label="Guests"
                                                onChange={handleChangeGuests}>
                                                <MenuItem value={2}>2</MenuItem>
                                                <MenuItem value={3}>3</MenuItem>
                                                <MenuItem value={4}>4</MenuItem>
                                                <MenuItem value={5}>5</MenuItem>
                                                <MenuItem value={6}>6</MenuItem>
                                                <MenuItem value={7}>7</MenuItem>
                                                <MenuItem value={8}>8</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Box>

                                </Box>

                            </Box>

                            <Box sx={{
                                display: ((value) !== null) & ((guests) !== '') ? 'flex' : 'none',
                                flexDirection: 'column',
                                alignItems: 'center', 
                                justifyContent: 'center',
                                width: '95%',
                                pt: '1rem',
                                pb: '1rem',
                                }}>
                                <Emailform2 date={value} party={guests}/>
                            </Box>

                        </Box>

                    }

                </Container>
            </Layout>
        </div>
    )
}